<template>
    <div class="cursor-pointer w-full">
        <loading :show="isLoading"/>
        <a :class="['flex bg-blue-500 p-2 rounded-lg gap-4', `${buttonWidth}`, buttonJustify]"
            @click="googleAuth">
            <div class="px-1"> 
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                    <path d="M498,264a4,4,0,0,1,4-4h20a4,4,0,0,1,4,4v20a4,4,0,0,1-4,4H502a4,4,0,0,1-4-4Z" transform="translate(-498 -260)" fill="#fff"></path>
                    <path d="M519.68,274.186a9.15,9.15,0,0,0-.145-1.636H512v3.1h4.3a3.68,3.68,0,0,1-1.6,2.414v2.007h2.586A7.8,7.8,0,0,0,519.68,274.186Z" transform="translate(-498 -260)" fill="#4285f4"></path>
                    <path d="M512,282a7.636,7.636,0,0,0,5.294-1.938l-2.586-2.007a4.827,4.827,0,0,1-7.185-2.535H504.85v2.073A8,8,0,0,0,512,282Z" transform="translate(-498 -260)" fill="#34a853"></path>
                    <path d="M507.524,275.523a4.737,4.737,0,0,1,0-3.04V270.41h-2.672a8.013,8.013,0,0,0,0,7.185l2.674-2.072Z" transform="translate(-498 -260)" fill="#fbbc05"></path>
                    <path d="M512,269.182a4.318,4.318,0,0,1,3.057,1.2l2.295-2.294A7.691,7.691,0,0,0,512,266a8,8,0,0,0-7.15,4.408l2.674,2.072a4.768,4.768,0,0,1,4.476-3.3Z" transform="translate(-498 -260)" fill="#ea4335"></path>
                </svg>
            </div>
            <span class="pt-1 text-white text-[16px]"> {{ buttonText }} </span>
        </a>
    </div>
</template>

<script>
import myMixin from "@/myMixin";
import Loading from "@/Jetstream/Loading";

export default {
    mixins:[myMixin],
    components: {
        Loading
    },
    props: {
        buttonWidth: {
            type: String,
            default: 'w-[250px]'
        },
        buttonJustify: {
            type: String,
            default: 'justify-center'
        },
        buttonText: {
            type: String,
            default: "Sign up with Google"
        },
        role: {
            default: null
        },
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        googleAuth() {
            this.isLoading = true;
            axios.get(`${this.baseUrl}auth/google?role=${this.determineRole()}`)
                .then( (res) => {
                    window.location.href = res.data;
                })
        },
        determineRole() {
            if( this.role ){
                return this.role;
            }
            
            let role = this.getParam('role');
            if ( role  === 'trainer' )
                return 'master';
            else if ( role === 'student' )
                return 'user';
            return null;
        }
    },
}
</script>